export const impactPartnersCategories = ["healthcare", "education", "culture"];

export const applicationPartnerDiagnosisTypes = [
  "ALS/MND",
  "Permanent speech impairment",
  "MSA",
  "Cancer",
  "Laryngectomees, Glossectomees",
  "PSP",
  "Stroke",
  "Blind and low-vision",
];
export const impactPartnerTypes = ["regular", "application"];
